module.exports = __webpack_public_path__ + "assets/img/9_362.79ee85fa.jpg";